import React, {Component} from 'react';
import EditContractView from "./EditContractView";
import {Growl} from "primereact/growl";
import {CatalogUserService} from "../../../service/catalog/CatalogUserService";
import {CatalogService} from "../../../service/catalog/CatalogService";
import {ContractOTCService} from "../../../service/admin/contractOTC/ContractOTCService";
import {validateNumberIntegersDecimals} from "../../../utils/formatters/Numbers";
import {withoutComma} from "../../../utils/calculate/Amount";


export default class EditContractContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables
     * se llaman los catálogos para llenar los dropdown.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.catalogUserService = new CatalogUserService();
        this.catalogService = new CatalogService();
        this.contractOTCService = new ContractOTCService();
        this.getInstitutionAccounts = this.getInstitutionAccounts.bind(this);
        this.getAforos = this.getAforos.bind(this);
        this.saveRadioButtonOption = this.saveRadioButtonOption.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            institutionAccounts: this.getInstitutionAccounts(),
            aforos: this.getAforos(),
            dataContract: this.props.location.state.contractSelected,
            otc: this.props.location.state.contractSelected.otc.toString(),
            disabledFields: this.props.location.state.contractSelected.otc === 0,
            isLoading: true,
        };

        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.returnContractOTCPage = this.returnContractOTCPage.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.isValidData = this.isValidData.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    /**
     * Función que consume a CatalogUserService y obtiene el catálogo de cuentas
     * de la institución, lo coloca en una variable del state y también
     * coloca el objeto que trae el elemento a editar.
     */
    getInstitutionAccounts() {
        let contractSelected = this.props.location.state.contractSelected;
        this.loading(true);
        this.catalogUserService.getCatalogInstitutionAccounts()
            .then(dataAccounts => {
                this.setState({
                    institutionAccounts: dataAccounts,
                    cuentaObject: dataAccounts.find((item) =>
                        item['cuenta'] === contractSelected['cuenta']),
                });
                this.loading(false);
            });
    }

    /**
     * Función que consume a CatalogService y obtiene el catálogo de aforos
     * de la institución, lo coloca en una variable del state y también
     * coloca el objeto que trae el elemento a editar.
     */
    getAforos() {
        let contractSelected = this.props.location.state.contractSelected;
        this.loading(true);
        this.catalogService.getCatalogAforo()
            .then(aforos => {
                this.setState({
                    aforos: aforos,
                    descrAforoObject: aforos.find((item) =>
                        item['idTipoAforo'] === contractSelected['idTipoAforo']
                    ),
                });
                this.loading(false);
            });
    }

    /**
     * Función que obtiene el valor que fue seleccionado en el radioButton
     * que se encuenta en la vista y lo coloca en una variable del state
     * así como en la variable que contiene el elemento a editar.
     * @param event
     */
    saveRadioButtonOption(event) {
        let dataContract = this.state.dataContract;
        dataContract['otc'] = parseInt(event.value);
        this.setState({
            otc: event.value,
            disabledFields: event.value === '0',
            dataContract: dataContract,
        });
    }

    /**
     * Función  que maneja el cambio de valor en los dropdown y en los campos de texto
     * Debido a que el campo dropdown, maneja un objeto. Hace esa conversión para
     * colocar el valor en el objeto a editar.
     * También valida que los campos numéricos sólo acepten x números enteros
     * y dos decimales. El número de enteros a manejar, se indica en el atributo id
     * del campo.
     * @param event
     */
    handleChangeValue(event) {
        const {name, value, id} = event.target;
        let dataContract = this.state.dataContract;
        if (name === 'cuenta') {
            dataContract[name] = value[name];
            this.setState({cuentaObject: value,})
        } else if (name === 'descrAforo') {
            dataContract[name] = value['detailAforo'];
            dataContract['idTipoAforo'] = value['idTipoAforo'];
            this.setState({descrAforoObject: value,})
        } else {
            let valueAux = withoutComma(value);
            if (this.isNumeric(valueAux)) {
                let newValue = validateNumberIntegersDecimals(Number(valueAux), id, 2);
                dataContract[name] = newValue;
            } else {
                dataContract[name] = value;
            }
        }
        this.setState({dataContract: dataContract,})
    }

    /**
     * Función que consume a ContractOTCService donde guarda los cambios que se hicieron
     * en la vista, sobre el elemento.
     * Hace tres validaciones antes de guardar el elemento.
     */
    saveChanges() {
        if (this.isValidData(this.state.dataContract)) {
            this.loading(true);
            let params = this.state.dataContract.otc === 0 ?
                {
                    idInstitucionPTT: this.state.dataContract.idInstitucion,
                    banderaOtc: this.state.dataContract.otc,
                } :
                {
                    idInstitucionPTT: this.state.dataContract.idInstitucion,
                    banderaOtc: this.state.dataContract.otc,
                    aforoOtc: this.state.dataContract.aforoOtcPorCien,
                    cuenta: this.state.dataContract.cuenta,
                    idAforo: this.state.dataContract.idTipoAforo,
                    lineaCredito: this.state.dataContract.lineaCredito,
                };

            this.contractOTCService.editBilateralAgreement(params)
                .then(resp => {
                    if (resp.message === 'Success') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'El registro ha sido editado correctamente',
                        };
                        this.returnContractOTCPage(message);
                    } else if (resp.error !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: resp.error});
                    }
                    this.loading(false);
                });
        }
    }

    isValidData(data) {
        let valid = true;
        if (data.otc === 1) {
            let cuenta = (data.cuenta).toString();
            let descrAforo = (data.descrAforo).toString();
            if (cuenta === "" || descrAforo === "" || descrAforo === "-") {
                this.growl.show({
                    severity: 'error',
                    summary: 'Error.',
                    detail: 'Llenar correctamente los campos requeridos'
                });
                valid = false;
            } else if (data.lineaCredito < data.lineaDisponible) {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'La línea de crédito no puede ser menor a la línea de crédito utilizada.'
                });
                valid = false;
            } else if ((data.lineaUtilizada > 0) && (data.otc === 0)) {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'No se puede realizar esta operación si se tienen prestamos vigentes.'
                });
                valid = false;
            }
        }
        return valid;
    }

    /**
     * Función que regresa a la pantalla de Contrato Bilateral OTC
     */
    returnContractOTCPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que valida si un string puede ser un número.
     * @param {String} num string del que se quiere saber si es número
     * @returns {boolean} la respuesta true or false
     */
    isNumeric(num) {
        return !isNaN(num)
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            institutionAccounts, aforos, dataContract,
            cuentaObject, descrAforoObject, otc,
            isLoading, disabledFields
        } = this.state;
        return (
            <EditContractView handleChangeValue={this.handleChangeValue}
                              messagesGrowl={messagesGrowl}
                              dataContract={dataContract}
                              institutionAccounts={institutionAccounts}
                              aforos={aforos}
                              disabledFields={disabledFields}
                              saveChanges={this.saveChanges}
                              returnContractOTCPage={this.returnContractOTCPage}
                              cuentaObject={cuentaObject}
                              descrAforoObject={descrAforoObject}
                              saveRadioButtonOption={this.saveRadioButtonOption}
                              otc={otc}
                              isLoading={isLoading}
            />
        );
    }
}
